import { render, staticRenderFns } from "./DontMiss.vue?vue&type=template&id=424db42e&scoped=true&"
import script from "./DontMiss.vue?vue&type=script&lang=js&"
export * from "./DontMiss.vue?vue&type=script&lang=js&"
import style0 from "./DontMiss.vue?vue&type=style&index=0&id=424db42e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424db42e",
  null
  
)

export default component.exports